import {
  SET_MIN_USEFUL_AREA,
  SET_MAX_USEFUL_AREA,
  SET_MIN_DATE,
  SET_MAX_DATE,
  SET_REALTY_TYPE,
  RESET_FILTERS,
  SET_MIN_MAX_AREA_LOCAL_FILTERS,
  SET_MIN_MAX_DATE_LOCAL_FILTERS,
  SET_IS_GRID_VIEW,
} from './charts.actions';

const initialState = {
  minUsefulArea: 0,
  maxusefulArea: 0,
  minDate: 0,
  maxDate: 0,
  realtyType: '',
  localFilters: {
    minMaxArea: {
      max: 0,
      min: 0,
    },
    minMaxDate: {
      max: 0,
      min: 0,
    },
    minMaxRealtyAge: {
      min: 0,
      max: 0,
    },
  },
  isGridView: true,
};

export default function chartsReducer(
  state = initialState,
  { type, payload }: { type: string; payload: any }
) {
  switch (type) {
    case SET_MIN_USEFUL_AREA:
      return { ...state, minUsefulArea: payload };
    case SET_MAX_USEFUL_AREA:
      return { ...state, maxusefulArea: payload };
    case SET_MIN_DATE:
      return { ...state, minDate: payload };
    case SET_MAX_DATE:
      return { ...state, maxDate: payload };
    case SET_REALTY_TYPE:
      return { ...state, realtyType: payload };
    case SET_MIN_MAX_AREA_LOCAL_FILTERS:
      return {
        ...state,
        localFilters: {
          ...state.localFilters,
          minMaxArea: payload,
        },
      };
    case SET_MIN_MAX_DATE_LOCAL_FILTERS:
      return {
        ...state,
        localFilters: {
          ...state.localFilters,
          minMaxDate: payload,
        },
      };
    case SET_IS_GRID_VIEW:
      return { ...state, isGridView: payload };
    case RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
}
